import fetch from '@/utils/fetch'

// 获取价格日历
export function loadPriceCalendar (data) {
  return fetch({
    url: '/website/packages/goods/allow-sale-list',
    method: 'post',
    data
  })
}

export function saveOrder (data) {
  return fetch({
    url: '/website/packages/order/create-general-order',
    method: 'post',
    data
  })
}
export function orderInfo (orderNo) {
  return fetch({
    url: `/website/packages/order/detail/${orderNo}`,
    method: 'post'
  })
}
// 载入子产品  （判断景点实名非实名用）
export function loadSubGoods (goodsId) {
  return fetch({
    url: `/website/packages/goods/get-item-list/${goodsId}`,
    method: 'post'
  })
}
